import { LabelInputAuto } from 'OkApp'
import OkTypedComponent from 'OkApp/components/OkTypedComponent'
import React from 'react'

export default function EditorComp(props) {
    return <>
        <OkTypedComponent typeComponente='InputComp' field='field' label='Nome Salvo' />
        <LabelInputAuto {...props} />     
    </>
}